import React from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { Image, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import './style.scss';

const Modal = (props) => {
  const {
    title,
    content,
    image,
    closeFunction,
  } = props;

  return (
    <div className="Modal">
      <div className="Modal__inner">
        <div
          className="Modal__close"
          onClick={() => closeFunction()}
        >
          <i className="icon icon-cross" />
        </div>
        <RemoveScroll className="Modal__content">
          <div className="Modal__content__inner">
            <Image
              className="Modal__content__inner__image"
              src={image}
            />
            <h2>{title}</h2>
            <WysiwygField
              property="schema:text"
              html={content}
            />
          </div>
        </RemoveScroll>
      </div>
      <div className="Modal__backdrop" onClick={() => closeFunction()} />
    </div>
  );
};

export default Modal;
